import React from 'react';
import ClipboardButton from 'react-clipboard.js';
import SyntaxHighlighter from 'react-syntax-highlighter';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
import Icon from 'components/common/Icon';
import TextInput from 'components/inputs/TextInput';
import Body from 'components/text/Body';
// ANTD
import message from 'antd/lib/message';

const CopyPasteButton = ({ url }) => (
  <ClipboardButton
    className="copy-paste-button"
    onSuccess={() => message.success('invite link copied!', 3)}
    data-clipboard-text={url}
  >
    <Icon type="copy" style={{ fontSize: 20 }} />
  </ClipboardButton>
);

class InviteArea extends React.PureComponent {
  render() {
    const { currentUser } = this.props;
    console.log(process.env);
    let organizationId = currentUser.profile.organizationId;
    let FORM_URL = `${process.env.REACT_APP_PUBLIC_URL}studio/client-invite/${organizationId}`;
    return (
      <div style={{ marginTop: 20 }}>
        <SectionHeader>INVITE CLIENTS</SectionHeader>
        <div style={{ width: 500, maxWidth: '100%' }}>
          <Body>Copy and Paste this link to an email or text message:</Body>
          <TextInput
            size="large"
            className="copy-past-invite-input"
            defaultValue={FORM_URL}
            addonAfter={<CopyPasteButton url={FORM_URL} />}
          />
          {/* <Body>or, copy and paste this iframe into your website or app:</Body>
          <SyntaxHighlighter language="html">
            {`<iframe src="${FORM_URL}" title="My Form" width="600" height="400" scrolling="yes" frameBorder="0"></iframe>`}
          </SyntaxHighlighter> */}
        </div>
      </div>
    );
  }
}

export default InviteArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/InviteArea/index.js